import {useTheme} from '@mui/material/styles';
import {useContext} from 'react';
import {ChartColor, ChartStatus, ChartTone} from '../types';
import {ChartHeightContext} from './chartHeight';

export const useChartTheme = () => {
  const theme = useTheme();
  const palette = {
    ...theme.palette.chart,
    grid: theme.palette.divider,
    axis: theme.palette.text.secondary,
    text: theme.palette.text.primary,
    cursor: theme.palette.action.hover,
    track: theme.palette.action.hover,
  };
  const statusColors: Record<ChartStatus, string> = {
    good: theme.palette.success.main,
    warning: theme.palette.warning.main,
    bad: theme.palette.error.main,
  };
  const tokens = theme.tokens.chart;
  const cardHeight = useContext(ChartHeightContext);

  const isChartColor = (color: string): color is ChartColor =>
    color in palette.series;

  const colorAt = (color: ChartTone | undefined, index: number) => {
    if (color === undefined) {
      return palette.series[
        tokens.seriesOrder[index % tokens.seriesOrder.length]
      ];
    }
    return isChartColor(color) ? palette.series[color] : color;
  };

  const axisTick = {
    fontSize: theme.tokens.text.metadata.fontSize,
    fill: palette.axis,
  };

  const statusColor = (status: ChartStatus) => statusColors[status];

  return {
    palette,
    tokens,
    colorAt,
    statusColor,
    axisTick,
    surface: theme.palette.background.paper,
    cardHeight,
    defaultHeight: cardHeight ?? tokens.height,
  };
};
